export default __webpack_public_path__ + "static/storyboard-b3d2c9773085e82b1f79038ca6dee847.png";